import type { FC } from 'react';
import { getElementId } from '@ContractBuilder/utils/get-element-id';

import { blockCreatorViewClasses } from '../classes';
import { BLOCK_CREATOR_STEPS } from '../constants';
import type { BlockCreatorStepId } from '../types';

interface BlockCreatorViewProps {
  id: string;
  step: BlockCreatorStepId;
}

export const BlockCreatorView: FC<BlockCreatorViewProps> = ({ id, step }) => {
  'use memo';
  const { component: StepComponent } = BLOCK_CREATOR_STEPS[step];

  return (
    <div id={getElementId('block-creator', id)} className={blockCreatorViewClasses(step)}>
      <StepComponent />
    </div>
  );
};
